import React, { useState, useEffect } from "react";
import Connect from "./Connect";
import { useSidebar } from "../context/useSidebar";

export default function Header() {
  const { toggleRightSidebar, isRightSidebarOpen } = useSidebar();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="header">
      <div className="header-content" style={{ paddingRight: isRightSidebarOpen && screenWidth > 1700 ? "26.75rem" : "" }}>
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>
            <ul className="navbar-nav header-right">
              <li className="nav-item dropdown notification_dropdown" style={{ zIndex: 9999 }} onClick={toggleRightSidebar}>
                <a className={`nav-link menu-wallet ${isRightSidebarOpen ? "btn-primary" : ""}`} href="#sec">
                  <i className="material-icons" color="red" style={{ color: isRightSidebarOpen ? "black" : "" }}>
                    {" "}
                    widgets{" "}
                  </i>
                </a>
              </li>
              <li className="nav-item dropdown notification_dropdown">
                <Connect />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}
